import { Box, Card, Text } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';

import { tileContentStyles, tileLinkStyles } from './styles';

type TourCountTileProps = {
  count: number;
  label: string;
  testId: string;
  href?: string;
};

const TourCountTile = ({ count, label, testId, href }: TourCountTileProps) => {
  const content = (
    <Card.Content>
      <Box css={tileContentStyles}>
        <Text textStyle="heading-xs">{count}</Text>
        <Text textStyle="body-sm" color="text.subtle">
          {label}
        </Text>
      </Box>
    </Card.Content>
  );

  // Card.BlockAnchor is tabIndex={-1} + aria-hidden, and Card.Root only wires role/tabIndex when given a
  // handler, so the card itself becomes the anchor to keep the tile keyboard- and screen-reader-reachable.
  if (href) {
    return (
      <Card.Root asChild elevated={false} interactive css={{ flex: 1 }}>
        <a
          href={href}
          aria-label={`${count} ${label}, view in tour calendar`}
          data-testid={testId}
          className={css(tileLinkStyles)}
        >
          {content}
        </a>
      </Card.Root>
    );
  }

  return (
    <Card.Root data-testid={testId} elevated={false} css={{ flex: 1 }}>
      {content}
    </Card.Root>
  );
};

export default TourCountTile;
